export default __webpack_public_path__ + "static/media/account-icon.0152be3c.svg";